<template lang="">
<!--~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Start Server Requirements Page
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~-->
<div class="server-section doc-wrapper doc-inner">
    <div class="row">
        <div class="col-xl-12">
            <div class="server-wrapper">
                <h2 class="inner-title">Website Version Update</h2>
                <small class="mb-30">To update your website version for old buyers, please follow these steps:</small>
                <ul class="configure-list">
                    <li class="mb-10"><b>Step 1:</b> Upload and Extract Update Files
                        <ol>
                            <li>Re-download the updated code from CodeCanyon.</li>
                            <li>Upload the <code>[project name]-web-update-file-[version-to-version]</code> files to your server in the expected directory.</li>
                            <div class="row">
                                <div class="col-xl-7">
                                    <a class="img-popup">
                                        <img src="/product/efunding/documentation/assets/images/webUpdate/file_manager.webp" alt="server">
                                    </a>
                                    <a class="img-popup">
                                        <img src="/product/efunding/documentation/assets/images/webUpdate/file_upload.webp" alt="server">
                                    </a>
                                    <a class="img-popup">
                                        <img src="/product/efunding/documentation/assets/images/webUpdate/select_file.webp" alt="server">
                                    </a>
                                    <a class="img-popup">
                                        <img src="/product/efunding/documentation/assets/images/webUpdate/file_uploaded.webp" alt="server">
                                    </a>
                                </div>
                            </div>
                            <li>Extract the zip file inside the <code>public_html</code> path.</li>
                            <div class="row">
                                <div class="col-xl-7">
                                    <a class="img-popup">
                                        <img src="/product/efunding/documentation/assets/images/webUpdate/extract_file.webp" alt="server">
                                    </a>
                                </div>
                            </div>
                            <small><b class="text--danger">Note:</b> Make sure to replace <code>/path/to/your/project</code> with the actual path to your project directory.</small>
                        </ol>
                    </li>
                    <li><b>Step 2:</b> Execute Update Commands in Terminal
                        <ol>
                            <li>After uploading and extracting the update files, proceed with the following commands in your terminal:</li>
                        </ol>
                    </li>
                    <ul class="mt-20">
                        <h5 class="mb-20">Update from v2.4.0 to v2.5.0:</h5>
                        <ol class="mb-30">
                            <pre class="prettyprint">
                                <code>composer update</code><br>
                                <code>php artisan migrate</code><br>
                                <code>php artisan db:seed --class=Database\\Seeders\\Update\\UpdateFeatureSeeder</code><br>
                                <code>php artisan storage:link</code><br>
                                <code>php artisan o:c</code>
                            </pre>
                        </ol>
                        <li className='mb-10'>
                            <span className="leading-[28px] text-[#000000] text-md font-bold">
                                Nginx Server Configuration (Important)
                            </span>
                            <p>
                                If you are using Nginx, make sure the Document Root (entry
                                point) is correctly set.
                            </p>
                            <h5>Correct:</h5>
                            <div className="cmd-run relative bg-[#292d3e] rounded-lg overflow-x-auto transition mt-2 p-4">
                                <code className="text-sm">
                                <span className="text-[#F97583]">
                                    {"{project_path}/public"}
                                </span>
                                </code>
                            </div>
                        </li>
                    </ul>

                    <ul class="mt-20">
                        <h5 class="mb-20">Update from v2.3.0 to v2.4.0:</h5>
                        <ol class="mb-30">
                            <pre class="prettyprint">
                                <code>composer update && php artisan migrate</code><br>
                                <code>php artisan db:seed --class=Database\\Seeders\\Update\\UpdateFeatureSeeder</code><br>
                                <code>php artisan o:c</code>
                            </pre>
                        </ol>
                    </ul>
                    <ul class="mt-20">
                        <h5 class="mb-20">Update from v2.2.0 to v2.3.0:</h5>
                        <ol class="mb-30">
                            <pre class="prettyprint">
                                <code>composer update && composer dumpautoload && php artisan migrate</code><br>
                                <code>php artisan db:seed --class=Database\\Seeders\\Update\\PaymentGatewaySeeder</code><br>
                                <code>php artisan db:seed --class=Database\\Seeders\\Update\\CategoryTypeSeeder</code><br> 
                                <code>php artisan db:seed --class=Database\\Seeders\\Update\\SystemMaintenanceSeeder</code><br>
                                <code>php artisan db:seed --class=Database\\Seeders\\Update\\DonationTypeSeeder</code><br>
                                <code>php artisan db:seed --class=Database\\Seeders\\Update\\UpdateFeatureSeeder</code><br>
                                <code>php artisan db:seed --class=Database\\Seeders\\Update\\LanguageSeeder</code><br>
                                <code>php artisan optimize:clear</code>
                            </pre>
                        </ol>
                    </ul>
                    <ul class="mt-20">
                        <h5 class="mb-20">Update from v2.1.0 to v2.2.0:</h5>
                        <ol class="mb-30">
                            <pre class="prettyprint">
                                <code>composer update && composer dumpautoload && php artisan migrate</code><br>
                                <code>php artisan db:seed --class=Database\\Seeders\\Update\\PaymentGatewaySeeder</code><br>
                                <code>php artisan db:seed --class=Database\\Seeders\\Update\\UpdateFeatureSeeder</code><br> 
                                <code>php artisan optimize:clear</code>
                            </pre>
                        </ol>
                    </ul>
                    <ul class="mt-20">
                        <h5 class="mb-20">Update from v2.0.0 to v2.1.0:</h5>
                        <ol class="mb-30">
                            <pre class="prettyprint">
                                <code>composer update && composer dumpautoload</code><br>
                                <code>php artisan db:seed --class=Database\\Seeders\\Update\\UpdateFeatureSeeder</code><br>
                                <code>php artisan passport:install --force</code>
                            </pre>
                        </ol>
                    </ul>
                    <ul class="mt-20">
                        <h5 class="mb-20">Update from v1.1.0 to v2.0.0:</h5>
                        <ol class="mb-30">
                            <pre class="prettyprint">
                                <code>composer update && composer dumpautoload && php artisan migrate</code><br>
                                <code>php artisan db:seed --class=Database\\Seeders\\Admin\\AppSettingsSeeder</code><br>
                                <code>php artisan db:seed --class=Database\\Seeders\\Admin\\BasicSettingsSeeder</code><br>
                                <code>php artisan db:seed --class=Database\\Seeders\\Admin\\LanguageSeeder</code><br>
                                <code>php artisan db:seed --class=Database\\Seeders\\Admin\\SetupPageSeeder</code><br>
                                <code>php artisan passport:install --force</code>
                            </pre>
                        </ol> 
                    </ul>
                    <ul class="mt-20">
                        <h5 class="mb-20">Update from v1.0.0 to v1.1.0:</h5>
                        <ol class="mb-30">
                            <pre class="prettyprint">
                                <code>composer update && composer dumpautoload && php artisan migrate</code><br>
                                <code>php artisan db:seed --class=Database\\Seeders\\Admin\\AppSettingsSeeder</code><br>
                                <code>php artisan db:seed --class=Database\\Seeders\\Admin\\BasicSettingsSeeder</code><br>
                                <code>php artisan passport:install --force</code>
                            </pre>
                        </ol>
                    </ul>
                    <p><b class="text--danger">Conclusion:</b> By following these steps and executing the provided commands, you can successfully update your website version for old buyers. Remember to configure the update files properly before executing the commands to ensure they work as intended. If you encounter any issues, double-check your configurations and seek assistance if needed.</p>
                </ul>
            </div>
        </div>
    </div>
</div>
<div class="page-change-area">
    <div class="navigation-wrapper">
        <router-link :to="{ name: 'iOSAppDeployment'}" class="left"><i class="las la-angle-left me-1"></i> iOS App Deployment</router-link>
        <router-link :to="{ name: 'AppVersionUpdate'}" class="right">App Version Update <i class="las la-angle-right ms-1"></i></router-link>
    </div>
</div>
<!--~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    End Server Requirements Page
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~-->
</template>

<script>
export default {
    name: 'WebsiteVersionUpdatePage',
}
</script>